import { PropsWithChildren, memo, useMemo } from 'react';

import { CircularProgress } from '@mui/material';
import { UserPrivilegeName } from 'domain/UserProfile';

import { useAuthorization } from '../../hooks';

export const ProtectedComponent = memo(
  ({
    requiredPrivileges,
    children,
  }: PropsWithChildren<{
    requiredPrivileges?: (keyof typeof UserPrivilegeName)[];
  }>) => {
    const { isAnswerPending, hasPrivilege } = useAuthorization();
    const isAllowed = useMemo(
      () => (requiredPrivileges ? hasPrivilege(requiredPrivileges.map((p) => UserPrivilegeName[p])) : false),
      [hasPrivilege, requiredPrivileges]
    );

    if (isAnswerPending) {
      return <CircularProgress style={{ margin: 'auto' }} size={50} />;
    }
    return isAllowed ? <>{children}</> : null;
  }
);
